import { Testimonial } from '../types/testimonial';

export const testimonialsData: Testimonial[] = [
  {
    name: "Petko Banchev",
    position: "Unity / .NET Developer",
    linkedinUrl: "https://www.linkedin.com/in/petko-banchev/",
    quote: "Iain was great to work with. A skilled Unity dev who was always up to date with the latest tech and had a real passion for AI that brought fresh ideas to the table.",
    avatar: "https://media.licdn.com/dms/image/v2/D4E03AQESfwJTrhyNKw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1670871708469?e=1766016000&v=beta&t=XHMvrftcIFsCKWlyPjeupW9ucUKaaSld3d2isMyZtCc"
  },
  {
    name: "Arjen de Aldrey", 
    position: "Lead Developer",
    company: "VR-Innovations",
    linkedinUrl: "https://www.linkedin.com/in/arjendealdrey/",
    quote: "Iain is a great coworker! Was always on time with the planned sprint tasks, gladly helped out others and best of all, he's a great person to talk to.",
    avatar: "https://media.licdn.com/dms/image/v2/C4E03AQFhoa4gC9n37A/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1661193617438?e=1766016000&v=beta&t=SLo-9ECBU5bXhfDP8OBhQMj-V6HAR1bq7-MEpyNqXos"
  },
  {
    name: "Yvens Serpa",
    position: "Graphics Engineer & Lecturer", 
    company: "Saxion University of Applied Sciences",
    linkedinUrl: "https://www.linkedin.com/in/yvens-serpa/",
    quote: "Iain is a very creative designer and developer, with a good sense of where to focus his energies to (quickly) turn his ideas into working prototypes. He is also a very nice person to have around. 🤓",
    avatar: "https://media.licdn.com/dms/image/v2/D4E03AQEDJeEQhryNDQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1712162430673?e=1766016000&v=beta&t=rNR5CXOqY6mi3jkYp2ohhr-JK70ghMguw1Ww7bqDL1g"
  },
  {
    name: "Lena Van",
    position: "Artist",
    linkedinUrl: "https://www.linkedin.com/in/lena-van/",
    quote: "Iain comes up with great creative ideas for projects and is able to create playable prototypes really quick. Working with him during game jam events has brought fun results that are enjoyed by many!",
    avatar: "https://media.licdn.com/dms/image/v2/D4E03AQHYlsqZjO5YMw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1702325527923?e=1766016000&v=beta&t=faHlU3gf3ExxLMfCzyiGc8tSJqKBBk5xaL-0zzukNM0"
  },
  {
    name: "Sil Faber",
    position: "Developer",
    linkedinUrl: "https://www.linkedin.com/in/sil-faber-b3700a247/",
    quote: "Iain works really hard and gets things done fast when he's focused. His enthusiasm and vibe are super contagious, so he's always lifting the team's mood.",
    avatar: "https://media.licdn.com/dms/image/v2/C4D03AQFYa3b_w3PCog/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1659010198249?e=1766016000&v=beta&t=Rn1QS2Jkc8xf_m_MiquQaGoLj4fZi44ZzII_biMiWWo"
  },
  {
    name: "Judah Rosaria",
    position: "Developer",
    linkedinUrl: "https://www.linkedin.com/in/judah-rosaria-105b8a188/",
    quote: "Iain is a dedicated professional who brings both technical expertise and creative problem-solving to every project. His collaborative approach makes him a valuable team member.",
    avatar: "https://media.licdn.com/dms/image/v2/D4E03AQGAm72YQdEwVw/profile-displayphoto-shrink_800_800/B4EZcbHXAtHcAc-/0/1748506604539?e=1766016000&v=beta&t=l5ZbV-1D9y5ac4z9QiyHXWlHRB6cU0uWJYv-Cn3fdAo"
  },
  {
    name: "Osama Boumelhem",
    position: "Designer",
    linkedinUrl: "https://www.linkedin.com/in/osama-boumelhem-442846257/",
    quote: "Few developers I know have the tenacity that Iain does. He is clear, organized, and direct in his work. ",
    avatar: "https://media.licdn.com/dms/image/v2/D4E03AQE4Vtx85B8-NA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1713096315557?e=1766016000&v=beta&t=tPA4MRGzulfSBqD151ggtbwwx8nU4SLCVcq3sAvZibg"
  }
];
